import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const ArrowLeftRight = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="93" viewBox="0 0 93 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.0691 73.3341L0.311638 37.1508L25.0691 0.966436V17.6569H67.8419V0.966436L92.5993 37.1508L67.8419 73.3341V56.6445H25.0691V73.3341Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
